import React, { useState, useEffect, FunctionComponent } from 'react';
import { Environment } from 'react-relay';
import { useSelector } from 'react-redux';

import { trackConsumerSourcingTooltip } from './helpers/pdpSharedConsumerSourcingTooltipDisplayHelpers';

const PdpRespConsumerSourcingTooltipRenderer = React.lazy(() =>
    import(
        /* webpackChunkName: "PdpRespConsumerSourcingTooltipRenderer" */ './PdpRespConsumerSourcingTooltipRenderer'
    )
);

type ReduxState = {
    relayVariables: {
        variables: {
            itemId: string;
        };
    };
};

type ComponentProps = {
    userId: string;
    environment: Environment;
};

export const PdpRespConsumerSourcingTooltipLoader: FunctionComponent<ComponentProps> = ({
    userId,
    environment,
}) => {
    const [isOpen, setIsOpen] = useState(true);
    const relayVariables = useSelector((state: ReduxState) => state.relayVariables.variables);
    const itemId = relayVariables?.itemId;
    useEffect(() => {
        trackConsumerSourcingTooltip({ action: 'modal view' });
    }, []);

    return isOpen ? (
        <React.Suspense fallback={null}>
            <PdpRespConsumerSourcingTooltipRenderer
                environment={environment}
                itemId={itemId}
                userId={userId}
                onClose={() => setIsOpen(false)}
            />
        </React.Suspense>
    ) : null;
};

export default PdpRespConsumerSourcingTooltipLoader;
